export const ALERT_HISTORY_COLLECTION = 'alerts';
export const ALERT_RULES_COLLECTION = 'alert-rules';
